<wr-new-data-table headerText="Emails"
                   localStorageIdentifier="email-overview"
                   [loadItemsFunction]="loadEmails"
                   [showNewButton]="false"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToEmail($event)"
                   [form]="form"
                   [isAdmin]="isAdmin()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="datePicker">Zeitraum</label>
          <wr-date-range-picker id="datePicker" formControlName="selectedRange"
                                [showTodayButton]="true"></wr-date-range-picker>
        </div>
        <div class="filter-control-group">
          <label class="label" for="emailType">Typ</label>
          <wr-email-type-select id="emailType" formControlName="emailType"></wr-email-type-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="emailFilter">Empfänger E-Mail-Adresse</label>
          <input type="text" nbInput id="emailFilter" formControlName="emailFilter" placeholder="E-Mail-Adresse...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="userId">Versender</label>
          <wr-user-select id="userId" formControlName="user" [tenantIds$]="senders$"></wr-user-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="receiverId">Empfänger</label>
          <wr-user-select id="receiverId" formControlName="receiver" [tenantIds$]="receivers$"></wr-user-select>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template dataColumn let-email key="subject" display="Betreff">
    @if (email.subject) {
      {{ email.subject }}
    }
  </ng-template>
  <ng-template
    dataColumn
    let-email
    key="sender"
    [sortable]="false"
    exportKey="user.fullName"
    display="Versender">
    <wr-user-badge [user]="email.user"></wr-user-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-email
    key="receiver"
    [sortable]="false"
    [exportValue]="exportReceiver"
    display="Empfänger">
    @if (email) {
      <div>
        {{ displayReceiver(email) }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-email
    key="created"
    exportKey="created"
    display="Datum">
    @if (email.created) {
      {{ email.created | date: 'dd.MM.yyyy' }}
    }
  </ng-template>

  <ng-template dataColumn let-email key="emailType" display="Email Typ">
    @if (email.emailType) {
      {{ email.emailType | emailTypeTranslation }}
    }
  </ng-template>
  <ng-template dataColumn let-email key="download" display="Download" [sortable]="false" [exportable]="false">
    <button nbButton
            status="basic"
            nbTooltip="Neu generieren"
            (click)="onDownloadClick(email.id, $event)">
      <nb-icon pack="eva" icon="download-outline"></nb-icon>
    </button>
  </ng-template>
</wr-new-data-table>
